import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import {
  Chat,
  ExpandLess,
  ExpandMore,
  MarkUnreadChatAlt,
} from '@mui/icons-material';
import { DrawerButton, ExpandIcon } from '.';

type Props = {
  openAllChat: boolean;
  setOpenAllChat: (open: boolean) => void;
  unreadAllChat: boolean;
};

export const DrawerButtonAllChat = ({
  openAllChat,
  setOpenAllChat,
  unreadAllChat,
}: Props) => {
  const theme = useTheme();

  return (
    <DrawerButton
      variant="contained"
      sx={{
        [theme.breakpoints.between(0, 1024)]: { left: 368 },
        [theme.breakpoints.up(1024)]: { right: 'calc(50% - 144px)' },
        position: 'absolute',
        height: '100%',
        border: !openAllChat
          ? `1px solid ${theme.palette.primary.dark}`
          : 'none',
        borderBottom: 'none',
      }}
      onClick={() => setOpenAllChat(!openAllChat)}
    >
      <Stack direction={'row'} spacing={1} width={'100%'} marginX={2}>
        {unreadAllChat ? (
          <MarkUnreadChatAlt
            sx={{
              color: 'info.main',
            }}
          />
        ) : (
          <Chat />
        )}
        <Typography textTransform={'capitalize'}>All Chat</Typography>
      </Stack>
      <ExpandIcon>{openAllChat ? <ExpandMore /> : <ExpandLess />}</ExpandIcon>
    </DrawerButton>
  );
};
